import type * as SchemaTypes from '../types';

import { gql } from '@apollo/client';
export type CompanySelectionItemFragment = (
  { __typename: 'CompanyOptions' }
  & Pick<SchemaTypes.CompanyOptions, 'id' | 'displayName' | 'countryCode'>
  & { availableModules?: SchemaTypes.Maybe<(
    { __typename: 'AvailableModules' }
    & Pick<SchemaTypes.AvailableModules, 'hasGiftVoucherModules'>
  )> }
);

export const CompanySelectionItemFragmentDoc = /*#__PURE__*/ gql`
    fragment CompanySelectionItem on CompanyOptions {
  id
  displayName
  countryCode
  availableModules {
    hasGiftVoucherModules
  }
}
    `;